<div *ngIf="loading" class="text-center py-4">
  Loading preview...
</div>


<div *ngIf="!loading && statusData == null">
  <h4 class="mb-0">{{matrix_name}}</h4>
  <hr/>
  <div *ngFor="let stage of previewData; let i=index;">
    <h4>
      Level {{ i+1 }}
    </h4>
    <div class="horizontal-scroll mb-2">
      <div class="p-1 flex align-items-center">

        <ng-container *ngFor="let cluster of getGroupClusters(stage.groups); let ci = index">

          <!-- OR between clusters -->
          <div *ngIf="ci !== 0" class="operator align-self-center mx-2" style="background-color:#F3F3F3">OR</div>

          <!-- Cluster: bordered box when multiple AND-connected groups -->
          <div [class.cluster-box]="cluster.length > 1" class="flex align-items-center flex-shrink-0">

            <ng-container *ngFor="let group of cluster; let gi = index">

              <!-- AND between groups within cluster -->
              <div *ngIf="gi !== 0" class="operator align-self-center mx-2" style="background-color:#F3F3F3">AND</div>

              <div class="mb-3 pl-3">
                <div class="ml-3">
                  {{ group.name }}
                </div>
                <ul class="ml-3">
                  <li *ngFor="let user of group.users">
                    <p-avatar [label]="getInitals(user.name)" styleClass="text-center mb-3" size="large"
                      [style]="{ 'background-color': '#ece9fc', color: '#2a1261' }" shape="circle" />

                    <span class="user_name" [pTooltip]="user.name">
                      <ng-container *ngIf="group.users.length > 3; else fullNames">
                        {{ user.name | slice:0:10 }}
                        <span *ngIf="user.name.length > 10">...</span>
                      </ng-container>

                      <ng-template #fullNames>
                        {{ user.name }}
                      </ng-template>
                    </span>
                  </li>
                </ul>
                <div class="text-center">
                  <span class="summary">{{ group.approval_summary }}</span>
                </div>
              </div>

            </ng-container>

          </div>

        </ng-container>

      </div>
    </div>

  </div>
</div>


<div *ngIf="!loading && statusData != null">
  <h4 class="mb-0">{{statusData.matrix_name}}</h4 >
  <hr />
  <div *ngFor="let flow of statusData.flows; let i = index" class="mb-4">

    <!-- Stage Header -->
    <h4 class="stage-title">
      Level {{i+1}}
      <span class="stage-status action-badge" [ngClass]="flow.status.toLowerCase()">{{ flow.status.replace('_', ' ') }}</span>
    </h4>

    <div class="horizontal-scroll mb-2">
      <div class="p-1 flex align-items-center">

        <ng-container *ngFor="let cluster of getGroupClusters(flow.groups); let ci = index">

          <!-- OR between clusters -->
          <div *ngIf="ci !== 0" class="operator-badge align-self-center mx-2">OR</div>

          <!-- Cluster: bordered box when multiple AND-connected groups -->
          <div [class.cluster-box]="cluster.length > 1" class="flex align-items-center flex-shrink-0">

            <ng-container *ngFor="let group of cluster; let gi = index">

              <!-- AND between groups within cluster -->
              <div *ngIf="gi !== 0" class="operator-badge align-self-center mx-2">AND</div>

              <div class="mb-3">

                <div class="group-title ml-3">
                  {{ group.name }}
                  <!-- <span class="summary">
                    ({{ group.status }})
                  </span> -->
                </div>

                <!-- Members -->
                <ul class="ml-3">
                  <li *ngFor="let member of group.members">

                    <p-avatar [label]="getInitals(member.user)" size="large" shape="circle"
                      [style]="getAvatarStyle(member.action)" [pTooltip]="member.why_cannot_act || member.action"
                      tooltipPosition="top"></p-avatar>

                    <span class="user_name" [pTooltip]="member.user">
                      <ng-container *ngIf="group.members.length > 3; else fullName">
                        {{ member.user | slice:0:10 }}
                        <span *ngIf="member.user.length > 10">...</span>
                      </ng-container>

                      <ng-template #fullName>
                        {{ member.user }}
                      </ng-template>
                    </span>

                    <!-- Action badge -->
                    <span class="action-badge" [ngClass]="member.action.toLowerCase()">
                      {{ member.action.replace('_', ' ') }}
                    </span>

                  </li>
                </ul>
                <div class="text-center">
                  <span class="summary">{{ group.approval_summary }}</span>
                </div>

              </div>

            </ng-container>

          </div>

        </ng-container>

      </div>
    </div>

  </div>
</div>
